
import React, {useEffect, useMemo, useState} from "react"
import {Box, Flex, Spinner} from "@chakra-ui/react";


const TagItemHeader = ({typeInfo, data, widthCard})=>{

    const widthCardFinal =widthCard==null?["100%","100%","25%"]:widthCard
    const contentDiv = useMemo (() => {
        if (data == null){
            return <Flex justifyContent={"center"}><Spinner color="text.100" /></Flex>
        }
        switch (typeInfo) {
            case "nb":
                return <>
                    <Flex sx={{
                        textAlign: 'center',
                        fontSize: 25,
                        fontWeight: 'bold',
                        letterSpacing: 1.8,minHeight: '50px',
                        justifyContent: 'center',
                        flexDirection: 'column'
                    }}>
                        <div>{data["nb"].toLocaleString()}</div>
                    </Flex>
                    <Box sx={{textAlign: 'center',textTransform:'uppercase',color:'text100',
                        lineHeight:1.2, fontSize: 16, fontWeight: 'body', letterSpacing: 1.5}}>Tweets</Box>
                    <Box sx={{textAlign: 'center',color:'text100',
                        lineHeight:1.2, fontSize: 13, fontWeight: 'body', letterSpacing: 1.5, }}>  /semaine</Box>
                       </>
            case "evol":
                const evol = data["t"] - 100
                return <>
                    <Flex sx={{
                        textAlign: 'center',
                        fontSize: 25,
                        fontWeight: 'bold',
                        letterSpacing: 1.8,
                        minHeight: '50px',
                        justifyContent: 'center',
                        flexDirection: 'column'
                    }}>
                        <div sx={{}}>{evol>0?"+":""}{evol}%</div>
                    </Flex>
                    <Box sx={{textAlign: 'center',textTransform:'uppercase',color:'text100',
                        lineHeight:1.2, fontSize: 16, fontWeight: 'body', letterSpacing: 1.5}}>Tendance</Box>
                </>
            case "vocab":
                const listToken = data["lt"].map(token => token.TC)
                return <>
                    <Flex sx={{
                        textAlign: 'center',
                        fontSize: 25,
                        fontWeight: 'bold',
                        letterSpacing: 1.8,
                        minHeight: ['50px','120px','120px'],
                        justifyContent: 'center',
                        flexDirection: 'column',
                    }}>
                        <Flex sx={{justifyContent:"center",fontWeight:'bold',flexWrap:'wrap',p:2}}>{listToken.map((token,i)=>
                            <Box key={i}
                                 sx={{bg:'secondary.100',ml:'4px',mr:'4px',mt:'4px',p:'2px', borderRadius:'4px',
                                borderColor:'secondary.300',borderStyle:'solid',borderWidth:'1px',
                                fontSize:'13px',color:'text.300',whiteSpace:'normal',fontFamily:'heading',fontWeight:'bold'}}>
                    {token} </Box>)} </Flex>
                    </Flex>
                    <Box sx={{textAlign: 'center',textTransform:'uppercase',lineHeight:1.2,color:'text.100',
                        fontSize: 16, fontWeight: 'body', letterSpacing: 1.5, pb:'8px'}}>Vocabulaire</Box>
                    </>
            default:
                return <div></div>
        }
    },[typeInfo,data])

    return <Box sx={{width:widthCardFinal, minHeight:'80px',mt:'8px'
    }}>
                   <Flex sx={{bg:'bg.300',ml:'8px',mr:'8px',mt:0,borderRadius:'5px',minHeight:'60px', height:'100%',
                      boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px',
                justifyContent:'center',flexDirection:'column'}}>
                       {contentDiv}
        </Flex>
            </Box>
}

export default TagItemHeader